module.exports = __webpack_public_path__ + "static/fullsignal-horizontal-logo-8fd4dbd40812aad5d560a0aba8895cb2.svg";